export default [
    {
        path: "/catalog",
        name: "Catalog",
        component: require("@/components/Catalog/CatalogListPage").default,
        meta: {
            breadcrumbs: [
                {
                    name: "Catalog",
                },
                {
                    name: "Product"
                }
            ]
        }
    },
    {
        path: "/catalog/form",
        name: "CatalogForm",
        component: require("@/components/Catalog/CatalogAddPage").default
    },
    {
        path: "/catalog/create",
        name: "AddCatalog",
        component: require("@/components/Catalog/AddCatalogPage").default,
        meta: {
            breadcrumbs: [
                {
                    name: "Catalog",
                    path: '/catalog',
                    query: {
                        type: "All",
                        typeName:"All",
                        name: "",
                        category: "All",
                        categoryName: "All",
                        status: "All",
                        itemPerPage: 10,
                        page: 1
                    }
                },
                {
                    name: "Product",
                    path: '/catalog',
                    query: {
                        type: "All",
                        typeName:"All",
                        name: "",
                        category: "All",
                        categoryName: "All",
                        status: "All",
                        itemPerPage: 10,
                        page: 1
                    }
                },
                { 
                    name: "Add Unit Product",
                }
            ]
        }
    },
    {
        path: "/catalog/edit/:id",
        name: "EditCatalog",
        component: require("@/components/Catalog/EditCatalog").default,
        meta: {
            breadcrumbs: [
                {
                    name: "Catalog",
                    path: '/catalog',
                    query: {
                        type: "All",
                        typeName:"All",
                        name: "",
                        category: "All",
                        categoryName: "All",
                        status: "All",
                        itemPerPage: 10,
                        page: 1
                    }
                },
                {
                    name: "Product",
                    path: '/catalog',
                    query: {
                        type: "All",
                        typeName:"All",
                        name: "",
                        category: "All",
                        categoryName: "All",
                        status: "All",
                        itemPerPage: 10,
                        page: 1
                    }
                },
                { 
                    name: "Edit Unit Product",
                }
            ]
        }
    },
    {
        path: "/catalog/bom/:id",
        name: "CatalogBom",
        component: require("@/components/Catalog/CatalogBomPage").default
    },
    {
        path: "/catalog/bom/add/:id",
        name: "CatalogBomAdd",
        component: require("@/components/Catalog/CatalogAddBomPage").default
    },
    {
        path: "/catalog/part-compatibility",
        name: "CatalogPartCompability",
        component: require("@/components/Catalog/PartCompabilityPage").default,
        meta: {
             breadcrumbs: [
                {
                    name: "Catalog",
                },
                {
                    name: "Part Compatibility",
                }
            ]
        }
    },
    {
        path: "/catalog/part-compatibility/detail/:id",
        name: "CatalogPartCompabilityDetail",
        component: require("@/components/Catalog/PartCompabilityDetailPage").default,
        meta: {
             breadcrumbs: [
                {
                    name: "Catalog",
                },
                {
                    name: "Part Compatibility",
                    path: '/catalog/part-compatibility'
                },
                {
                    name : 'Details',
                    query: {
                        itemName : '',
                        itemGroup : '',
                    }
                }
            ]
        }
    },
    {
        path: "/catalog/batch-number-list",
        name: "BatchNumberList",
        component: require("@/components/Catalog/BatchNumberListPage").default,
        meta: {
            breadcrumbs: [
                {
                    name: "Catalog",
                },
                { 
                    name: "Batch Number List",
                }
            ]
        }
    },
    // {
    //   path: "/stock/catalog",
    //   name: "Stock",
    //   component: require("@/components/Stock/StockCatalogPage").default
    // },
    // {
    //   path: "/stock/catalog/views/:id",
    //   name: "StockViews",
    //   component: require("@/components/Stock/Stock2Page").default
    // },
]


// WEBPACK FOOTER //
// ./src/router/catalog/index.js